import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://ddcvdrzxizymltrllbnj.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRkY3Zkcnp4aXp5bWx0cmxsYm5qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQxNzA5ODksImV4cCI6MjA3OTc0Njk4OX0.sr-o5NE3FFIXGXNXe4iPmg6aAzavelCmTQ0FOfcXLT0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
